export const TRANSITION_DURATION = 1000;
export const DEFAULT_IMAGE_SLIDE_DELAY = 6_000;
export const DEFAULT_VIDEO_SLIDE_DELAY = 7_000;
export const DEFAULT_VIDEO_SLIDE_DELAY_SECONDS = 7;

// Local constants to avoid external dependencies
export const CARD_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
};
